import {
  mapActions,
  mapGetters
} from 'vuex';
import GestionArticleI18n from './GestionArticles.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['categories', 'articles', 'articlesLoading', 'familles']),
    modalTitle() {
      if (this.creationMode === 'create') {
        return "Créer un nouvel article"
      } else {
        return "Modifier un article"
      }
    }
  },

  data() {
    return {
      creationMode: 'create',
      currentArticleName: '',
      currentArticleCode: '',
      currentArticleDesc: '',
      currentArticlePrix: 0,
      currentArticleReduc: 0,
      currentDisplayInWebsite: true,
      currentArticleId: 0,
      currentArticleStock: 0,
      currentPoids: 0,
      selectedCategorie: null,
      selectedFamille: null,
      photo: null,
      currentPhotoPreview1: null,
      photo2: null,
      currentPhotoPreview2: null,
      photo3: null,
      currentPhotoPreview3: null,
      globalPromotion: 0
    };
  },

  watch: {},

  methods: {
    ...mapActions(['getFamilles', 'getArticles', 'createArticle', 'updateArticle', 'deleteArticle', 'applyGlobalPromotion']),
    /**
     * Function to manage categories
     */
    createCurrentArticle() {
      let formData = new FormData()
      if (this.creationMode === 'create') {
        formData.append('nom', this.currentArticleName)
        formData.append('code', this.currentArticleCode)
        formData.append('description', this.currentArticleDesc)
        formData.append('prix', this.currentArticlePrix)
        formData.append('reduction', this.currentArticleReduc)
        formData.append('quantite_stock', this.currentArticleStock)
        formData.append('poids', this.currentPoids)
        if (this.currentDisplayInWebsite) {
          formData.append('actif', 1)
        } else {
          formData.append('actif', 0)
        }
        formData.append('photo_1', this.photo)
        if (this.photo2) {
          formData.append('photo_2', this.photo2)
        }
        if (this.photo3) {
          formData.append('photo_3', this.photo3)
        }
        const article = {
          formData: formData,
          catId: this.selectedCategorie.id,
          famId: this.selectedFamille.id
        }
        this.createArticle(article).then(res => {
          this.loadArticles()
          this.hideModalAddArticle()
        }).catch(err => {
          console.log(err)
        })
      } else {
        formData.append('nom', this.currentArticleName)
        formData.append('code', this.currentArticleCode)
        formData.append('description', this.currentArticleDesc)
        formData.append('prix', this.currentArticlePrix)
        formData.append('reduction', this.currentArticleReduc)
        formData.append('quantite_stock', this.currentArticleStock)
        formData.append('poids', this.currentPoids)
        if (this.currentDisplayInWebsite) {
          formData.append('actif', 1)
        } else {
          formData.append('actif', 0)
        }
        if (this.photo) {
          formData.append('photo_1', this.photo)
        } else if (!this.photo && !this.currentPhotoPreview1) {
          formData.append('delete_photo_1', 1)
        }
        if (this.photo2) {
          formData.append('photo_2', this.photo2)
        } else if (!this.photo2 && !this.currentPhotoPreview2) {
          formData.append('delete_photo_2', 1)
        }
        if (this.photo3) {
          formData.append('photo_3', this.photo3)
        } else if (!this.photo3 && !this.currentPhotoPreview3) {
          formData.append('delete_photo_3', 1)
        }
        const article = {
          formData: formData,
          catId: this.selectedCategorie.id,
          famId: this.selectedFamille.id,
          id: this.currentArticleId
        }
        this.updateArticle(article).then(res => {
          this.loadArticles()
          this.hideModalAddArticle()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    removeArticle() {
      const article = {
        catId: this.selectedCategorie.id,
        famId: this.selectedFamille.id,
        id: this.currentArticleId,
      }
      this.deleteArticle(article).then(res => {
        console.log(res)
        this.loadArticles()
        this.hideModalDeleteArticle()
      }).catch(err => {
        console.log(err)
      })
    },

    applyPromotion() {
      const info = {
        promotion: this.globalPromotion
      }
      this.applyGlobalPromotion(info).then(res => {
        const info2 = {
          catId: this.selectedCategorie.id,
          famId: this.selectedFamille.id,
        }
        this.getArticles(info2).then(res => {
          this.hideModalPromotion()
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },

    showModalUpdateArticle(pArticle) {
      this.currentArticleId = pArticle.id
      this.currentArticleName = pArticle.nom
      this.currentArticleCode = pArticle.code
      this.currentArticleDesc = pArticle.description
      this.currentArticlePrix = pArticle.prix
      this.currentArticleReduc = pArticle.reduction
      this.currentArticleStock = pArticle.quantite_stock
      this.currentPoids = pArticle.poids
      if (pArticle.actif == 1) {
        this.currentDisplayInWebsite = true
      } else {
        this.currentDisplayInWebsite = false
      }
      this.currentPhotoPreview1 = pArticle.photoLink1
      this.currentPhotoPreview2 = pArticle.photoLink2
      this.currentPhotoPreview3 = pArticle.photoLink3
      this.photo = null
      this.photo2 = null
      this.photo3 = null
      this.creationMode = 'update'
      this.$refs['modal-add-article'].show()
    },
    showModalAddArticle() {
      this.currentArticleId = ''
      this.currentArticleCode = ''
      this.currentArticleName = ''
      this.currentArticleDesc = ''
      this.currentArticleOrder = 1
      this.currentArticlePrix = 0
      this.currentPoids = 0
      this.currentArticleReduc = 0
      this.currentDisplayInWebsite = false
      this.photo = null
      this.creationMode = 'create'
      this.$refs['modal-add-article'].show()
    },
    hideModalAddArticle() {
      this.$refs['modal-add-article'].hide()
    },
    showModalDeleteArticle(pId) {
      this.currentArticleId = pId
      this.$refs['modal-delete-article'].show()
    },
    hideModalDeleteArticle() {
      this.$refs['modal-delete-article'].hide()
    },
    showModalPromotion(pId) {
      this.currentArticleId = pId
      this.$refs['modal-promotion-article'].show()
    },
    hideModalPromotion() {
      this.$refs['modal-promotion-article'].hide()
    },
    changeCategorie() {
      this.getFamilles(this.selectedCategorie.id).then(res => {
        this.selectedFamille = this.familles[0]
        const info = {
          catId: this.selectedCategorie.id,
          famId: this.selectedFamille.id,
        }
        this.getArticles(info).then(res => {

        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    removePhoto1() {
      this.currentPhotoPreview1 = null
    },
    removePhoto2() {
      this.currentPhotoPreview2 = null
    },
    removePhoto3() {
      this.currentPhotoPreview3 = null
    },
    changeFamille() {
      const info = {
        catId: this.selectedCategorie.id,
        famId: this.selectedFamille.id,
      }
      this.getArticles(info).then(res => {}).catch(err => {
        console.log(err)
      })

    },
    loadArticles() {
      const info = {
        catId: this.selectedCategorie.id,
        famId: this.selectedFamille.id,
      }
      this.getArticles(info).then(res => {

      }).catch(err => {
        console.log(err)
      })
    },
    getPhotoLink(pPhotoLink) {
      return pPhotoLink + '?cacheKey=' + Date.now()
    }
  },

  filters: {
    currency: (value) => {
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },

  mounted() {
    this.selectedCategorie = this.categories[0]
    this.getFamilles(this.selectedCategorie.id).then(res => {
      this.selectedFamille = this.familles[0]
      const info = {
        catId: this.selectedCategorie.id,
        famId: this.selectedFamille.id,

      }
      this.getArticles(info).then(res => {

      }).catch(err => {
        console.log(err)
      })
    }).catch(err => {
      console.log(err)
    })
  },

  i18n: GestionArticleI18n,

};